import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, Tag } from "../Reveal";

export const OfferBanner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} className="relative min-h-[70vh] overflow-hidden flex items-center" data-testid="offer-banner-section">
      <motion.img src="/images/kitchen-island.png" alt="Modern kitchen with charcoal cabinets and a marble island" className="absolute inset-0 h-[116%] w-full object-cover -top-[8%]" style={{ y }} />
      <div className="absolute inset-0 bg-ink/65" />
      <div className="relative w-full mx-auto max-w-[1600px] px-5 sm:px-8 py-24 grid lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-8">
          <Tag light>Limited kitchen offer</Tag>
          <p className="mt-6 font-display font-semibold text-bone tracking-[-0.03em] leading-[0.94] text-[clamp(2.8rem,7vw,7.5rem)]" data-testid="offer-banner-headline">
            New cabinets + granite.<br /><span className="text-teal">$5K. Guaranteed.</span>
          </p>
          <p className="mt-6 max-w-xl text-lg sm:text-xl text-bone/80 leading-snug font-medium">Up to 18 cabinets and granite countertops, installed in days, for a flat $5,000. See how it works.</p>
        </Reveal>
        <Reveal className="lg:col-span-4 lg:justify-self-end" delay={0.15}>
          <Link to="/offer" data-testid="offer-banner-link" className="group inline-flex items-center gap-6 bg-bone text-ink font-display font-medium text-base sm:text-lg px-8 py-5 hover:bg-teal hover:text-bone transition-colors duration-300">
            Explore the $5K kitchen
            <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
